import {localStorageKey} from "@/api/config";
import Api from "@/api";

const LIVE_CHANNEL_DISPLAY_STORAGE_KEY = `${localStorageKey}-live-channel-display`;
const LIVE_CHANNEL_DISPLAY_CACHE_MS = 60 * 60 * 1000;
const LIVE_CHANNEL_DISPLAY_PLATFORMS = ["WEB"];

const getDefaultLiveChannelDisplay = () => LIVE_CHANNEL_DISPLAY_PLATFORMS.reduce((result, platform) => {
    result[platform] = {
        list: [],
        fetchedAt: 0,
    };
    return result;
}, {});

const getInitialLiveChannelDisplayState = () => {
    const defaultState = getDefaultLiveChannelDisplay();

    try {
        const storedValue = window.localStorage.getItem(LIVE_CHANNEL_DISPLAY_STORAGE_KEY);
        if (!storedValue) {
            return defaultState;
        }

        const parsedValue = JSON.parse(storedValue);
        return LIVE_CHANNEL_DISPLAY_PLATFORMS.reduce((result, platform) => {
            result[platform] = {
                list: parsedValue?.[platform]?.list || [],
                fetchedAt: parsedValue?.[platform]?.fetchedAt || 0,
            };
            return result;
        }, getDefaultLiveChannelDisplay());
    } catch (e) {
        return defaultState;
    }
};

const saveLiveChannelDisplayState = liveChannelDisplay => {
    window.localStorage.setItem(
        LIVE_CHANNEL_DISPLAY_STORAGE_KEY,
        JSON.stringify(liveChannelDisplay)
    );
};

const state = {
    liveChannelDisplay: getInitialLiveChannelDisplayState(),
};

const getters = {
    getLiveChannelDisplay: state => state.liveChannelDisplay,
};

const mutations = {
    updateLiveChannelDisplay(state, {platform, list, fetchedAt}) {
        state.liveChannelDisplay = {
            ...state.liveChannelDisplay,
            [platform]: {
                list,
                fetchedAt,
            },
        };
        saveLiveChannelDisplayState(state.liveChannelDisplay);
    },
};

const actions = {
    async ensureLiveChannelDisplay({state, commit}, {platform, force = false}) {
        const platformCache = state.liveChannelDisplay[platform];
        const now = Date.now();

        if (!force && platformCache && platformCache.fetchedAt > 0 && now - platformCache.fetchedAt < LIVE_CHANNEL_DISPLAY_CACHE_MS) {
            return platformCache.list;
        }

        try {
            const response = await Api.$subscript.getChannelDisplay({paging: false});
            const channelDisplayList = response?.result?.list || [];

            commit('updateLiveChannelDisplay', {
                platform,
                list: channelDisplayList,
                fetchedAt: now,
            });

            return channelDisplayList;
        } catch (e) {
            return platformCache?.list || [];
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
